import {createStaticRanges} from "react-date-range";
import moment from "moment/moment";
import {KeyConstant} from "../constant/keyConstant";

export const staticRanges = createStaticRanges([
    {
        label: 'Hôm nay',
        range: () => ({
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            text: KeyConstant.TODAY
        })
    },
    {
        label: 'Hôm qua',
        range: () => ({
            startDate: moment().subtract(1, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.YESTERDAY
        }),
    },
    {
        label: 'Tuần này',
        range: () => ({
            startDate: moment().startOf("week").toDate(),
            endDate: moment().endOf("week").toDate(),
            text: KeyConstant.THIS_WEEK
        }),
    },
    {
        label: 'Tuần trước',
        range: () => ({
            startDate: moment().subtract(1, "weeks").startOf("week").toDate(),
            endDate: moment().subtract(1, "weeks").endOf("week").toDate(),
            text: KeyConstant.LAST_WEEK
        }),
    },
    {
        label: 'Tháng này',
        range: () => ({
            startDate: moment().startOf("month").toDate(),
            endDate: moment().endOf("month").toDate(),
            text: KeyConstant.THIS_MONTH
        }),
    },
    {
        label: 'Tháng trước',
        range: () => ({
            startDate: moment().subtract(1, "months").startOf("month").toDate(),
            endDate: moment().subtract(1, "months").endOf("month").toDate(),
            text: KeyConstant.LAST_MONTH
        }),
    },
    {
        label: '7 ngày trước',
        range: () => ({
            startDate: moment().subtract(7, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.SEVEN_DAYS_AGO
        }),
    },
    {
        label: '28 ngày trước',
        range: () => ({
            startDate: moment().subtract(28, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.THIRTY_DAYS_AGO
        }),
    },
    {
        label: '90 ngày trước',
        range: () => ({
            startDate: moment().subtract(90, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.NINETY_DAYS_AGO
        }),
    }
]);
